<template>
  <!-- 声音 -->
  <div class="v-sound" :class="{ 'v-sound_yellow': type == 'yellow' }">
    <div
      class="video"
      :class="{ 'video-close': playingMusic }"
      @click="toggleMusic"
    ></div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "VSound",

  props: {
    type: {
      type: String,
      default: () => "",
    },
  },

  computed: {
    ...mapState(["playingMusic"]),
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {
    // 关闭音乐
    toggleMusic() {
      this.setTarget({
        name: "playingMusic",
        value: !this.playingMusic,
      });
    },
    ...mapMutations(["setTarget"]),
  },
};
</script>

<style lang="less">
.v-sound {
  .video {
    position: absolute;
    top: 60px;
    right: 45px;
    width: 90px;
    height: 90px;
    background-image: url("../assets/image/video02-open.png");
    background-size: 100% 100%;
    animation: rotate 6s linear infinite;
  }
  .video-close {
    background-image: url("../assets/image/video02-close.png");
    background-size: 100% 100%;
    animation-play-state: paused;
  }

  &_yellow {
    .video {
      background-image: url("../assets/image/video01-open.png");
      background-size: 100% 100%;
    }
    .video-close {
      background-image: url("../assets/image/video01-close.png");
      background-size: 100% 100%;
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
